export function findIndex (arr, predicate, ctx) {
  if (typeof Array.prototype.findIndex === 'function') {
    return arr.findIndex(predicate, ctx);
  }

  if (typeof predicate !== 'function') {
    throw new TypeError('predicate must be a function');
  }

  var list = Object(arr);
  var len = list.length;

  if (len === 0) {
    return -1;
  }

  for (var i = 0; i < len; i++) {
    if (predicate.call(ctx, list[i], i, list)) {
      return i;
    }
  }

  return -1;
}

export function find (array, predicate, context) {
  // cannot call Array.find because polyvore's Array.find is overriden with a
  // different signature
  // if (typeof Array.prototype.find === 'function') {
  //   return array.find(predicate, context);
  // }

  context = context || this;
  var length = array.length;
  var i;

  if (typeof predicate !== 'function') {
    throw new TypeError(predicate + ' is not a function');
  }

  for (i = 0; i < length; i++) {
    if (predicate.call(context, array[i], i, array)) {
      return array[i];
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/array.js
 **/